import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { media_url } from "../hooks/useBlog";

const SEO = ({ stitle, description, keyword, author, image }) => {
  const { currentCustomer } = useSelector((state) => state.store);
  return (
    <>
      <meta charSet="utf-8" />
      <title>
        {currentCustomer?.name || "Gestión Ciudad"} | {stitle}
      </title>
      <meta name="robots" content="all" />
      <meta name="description" content={description || "Gestión Ciudad"} />
      <meta name="keywords" content={keyword} />
      <link rel="icon" href={media_url(currentCustomer?.logo)} />
      <link
        rel="apple-touch-icon"
        href={
          currentCustomer?.logo ? media_url(currentCustomer?.logo) : undefined
        }
      />
      <meta
        name="author"
        content={author || currentCustomer?.name || "Gestión Ciudad"}
      />
      <meta name="image" content={image || media_url(currentCustomer?.logo)} />
      {/* add facebook meta data */}
      <meta property="og:title" content={stitle} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={image || media_url(currentCustomer?.logo)}
      />
      {/* add twitter meta data */}
      <meta name="twitter:title" content={stitle} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content={image || media_url(currentCustomer?.logo)}
      />
      {/* add x meta data */}
      <meta name="x:title" content={stitle} />
      <meta name="x:description" content={description} />
      <meta
        name="x:image"
        content={image || media_url(currentCustomer?.logo)}
      />
      {/* add google search meta data for best results */}
      <meta name="google:title" content={stitle} />
      <meta name="google:description" content={description} />
      <meta
        name="google:image"
        content={image || media_url(currentCustomer?.logo)}
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </>
  );
};
SEO.propTypes = {
  title: PropTypes.string,
};

export default SEO;
